/**
 * Retries applying a deferred service worker update after client-side navigation
 * (when `useUnsavedChangesGuard` was blocking SKIP_WAITING).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import pwaService from '@/services/pwaService';

export default function ServiceWorkerUpdateCoordinator() {
  const location = useLocation();

  useEffect(() => {
    pwaService.retryDeferredUpdateAfterNavigation();
  }, [location.pathname, location.search]);

  return null;
}
